import React, { useEffect, useState } from "react";
import ListarCampanas from "./listar/ListarCampanas";
import ConfiguracionCampanas from "./configuracion/ConfiguracionCampanas";
import styled from "styled-components";
import {useManageGetRequest} from "../../../hooks/useManageGetRequest/useManageGetRequest";
import {
    cuadroRequerimientosListarCampanasAPI,
} from "../../../consumers/backendApisUrls";

const Page = styled.div`
  display: flex;
  height: 95vh; 
`;

export default function MainCampanas() {
    const [campanas, setCampanas] = useState([]);
    const [campanaSeleccionada, setCampanaSeleccionada] = useState(null);
    const [executeManageGet] = useManageGetRequest();
    const [puedeCrearCampana, setPuedeCrearCampana] = useState(false);

    useEffect(() => {
        refreshListarCampanas();
    }, []);

    const refreshListarCampanas = async () => {
        const api = cuadroRequerimientosListarCampanasAPI();
        await executeManageGet(api, (res) => successListarCampanasCallback(res), false);
    }

    const successListarCampanasCallback = ({data}) => {
        setCampanas(data.Campanas);
        setPuedeCrearCampana(data.PuedeCrear);
        if (data.Campanas.length > 0)
            setCampanaSeleccionada(data.Campanas[0])
    }

    return (
        <Page>
            <ListarCampanas
                campanas={campanas}
                campanaSeleccionada={campanaSeleccionada}
                onSelect={setCampanaSeleccionada}
                refreshListarCampanas={refreshListarCampanas}
                puedeCrearCampana={puedeCrearCampana}
            />

            {campanaSeleccionada && (
                <ConfiguracionCampanas campana={campanaSeleccionada} />
            )}
        </Page>
    );
}
